/* Lit cart fixes (2026-09-28): cart drawer recommendations + free-shipping bar (multi-currency). */
(function () {
  if (window.__litCartfix) return;
  window.__litCartfix = true;

  var recsCache = {};

  if (!customElements.get('lit-cart-recs')) {
    customElements.define('lit-cart-recs', class extends HTMLElement {
      connectedCallback() {
        var pid = this.dataset.productId;
        var url = this.dataset.url;
        if (!pid || !url) return;
        var cacheKey = pid + '|' + (this.dataset.key || '');
        if (Object.prototype.hasOwnProperty.call(recsCache, cacheKey)) {
          this.innerHTML = recsCache[cacheKey];
          return;
        }
        var self = this;
        var sep = url.indexOf('?') === -1 ? '?' : '&';
        fetch(url + sep + 'section_id=lit-cart-recs&limit=10&intent=related&product_id=' + encodeURIComponent(pid))
          .then(function (r) { if (!r.ok) throw new Error('recs ' + r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var el = doc.querySelector('.lit-recs');
            var markup = el ? el.outerHTML : '';
            recsCache[cacheKey] = markup;
            if (self.isConnected) self.innerHTML = markup;
          })
          .catch(function () { /* keep server-rendered fallback */ });
      }
    });
  }

  if (!customElements.get('lit-free-shipping')) {
    customElements.define('lit-free-shipping', class extends HTMLElement {
      connectedCallback() {
        var d = this.dataset;
        if (!d.cartCurrency || d.cartCurrency === d.shopCurrency) return;
        var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '0');
        if (!rate) return; /* stay hidden rather than show a wrong amount */
        var threshold = Math.round(parseInt(d.threshold, 10) * rate);
        var total = parseInt(d.total, 10) || 0;
        var remaining = threshold - total;
        var fmt;
        try {
          fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: d.cartCurrency });
        } catch (e) { return; }
        var msg = this.querySelector('.lit-fs__msg');
        var fill = this.querySelector('.lit-fs__fill');
        if (!msg || !fill || !threshold) return;
        if (remaining > 0) {
          msg.innerHTML = 'You\u2019re <strong>' + fmt.format(remaining / 100) + '</strong> away from free shipping';
          this.classList.remove('lit-fs--done');
        } else {
          msg.textContent = 'You\u2019ve got free shipping';
          this.classList.add('lit-fs--done');
        }
        fill.style.width = Math.min(100, Math.floor((total * 100) / threshold)) + '%';
        this.hidden = false;
      }
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.lit-recs__add[data-variant-id]');
    if (!btn) return;
    event.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          btn.textContent = 'Unavailable';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lit-cart-recs', productVariantId: btn.dataset.variantId });
        }
        if (drawer && drawer.renderContents && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (e) { console.error(e); })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
      });
  });
})();
